import { render, staticRenderFns } from "./HqHrJiangLi.vue?vue&type=template&id=28fa0feb"
import script from "./HqHrJiangLi.vue?vue&type=script&lang=js"
export * from "./HqHrJiangLi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports